import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    EnvironmentProviders,
    Provider,
    inject,
    provideEnvironmentInitializer,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { AuthService } from 'app/core/auth/auth.service';
import { SnackBarService } from '../snackbar/snackbar-service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        MatSnackBar,
        SnackBarService,
        provideHttpClient(withInterceptors([authInterceptor])),
        provideEnvironmentInitializer(() => inject(AuthService)),
    ];
};
